export default "__VITE_ASSET__CTjRuxFZ__"